export const PERMISSIONS = {
    addonsCreate: 'addons:create',
    addonsDelete: 'addons:delete',
    addonsEdit: 'addons:edit',
    addonsView: 'addons:view',
    affiliatesCreate: 'affiliates:create',
    affiliatesDelete: 'affiliates:delete',
    affiliatesEdit: 'affiliates:edit',
    affiliatesView: 'affiliates:view',
    carsCreate: 'cars:create',
    carsDelete: 'cars:delete',
    carsEdit: 'cars:edit',
    carsView: 'cars:view',
    carsViewImage: 'cars:view-image',
    configurationsExtraStop: 'configurations:extra-stop',
    configurationsHome: 'configurations:home',
    configurationsMaxMilesSurge: 'configurations:max-miles-surge',
    configurationsMeetAndGreet: 'configurations:meet-and-greet',
    configurationsMessages: 'configurations:messages',
    configurationsView: 'configurations:view',
    customersCreate: 'customers:create',
    customersDelete: 'customers:delete',
    customersEdit: 'customers:edit',
    customersView: 'customers:view',
    discountCodesCreate: 'discount-codes:create',
    discountCodesDelete: 'discount-codes:delete',
    discountCodesEdit: 'discount-codes:edit',
    discountCodesView: 'discount-codes:view',
    driversCreate: 'drivers:create',
    driversDelete: 'drivers:delete',
    driversEdit: 'drivers:edit',
    driversView: 'drivers:view',
    permissionsAssign: 'permissions:assign',
    permissionsCreate: 'permissions:create',
    permissionsDelete: 'permissions:delete',
    permissionsEdit: 'permissions:edit',
    permissionsView: 'permissions:view',
    reservationsAddAddon: 'reservations:addAddon',
    reservationsAssign: 'reservations:assign',
    reservationsCancel: 'reservations:cancel',
    reservationsChangeStatus: 'reservations:change-status',
    reservationsComplete: 'reservations:complete',
    reservationsCreate: 'reservations:create',
    reservationsCreateWithInSixHours: 'reservations:create-withIn-six-hours', 
    reservationsCreateWithInTwentyFourHours:
    'reservations:create-withIn-twenty-four-hours',
    reservationsCreateWithoutPayment: 'reservations:create-without-payment',
    reservationsDelete: 'reservations:delete',
    reservationsDeleteAddon: 'reservations:deleteAddon',
    reservationsDetails: 'reservations:details',
    reservationsDraft: 'reservations:draft',
    reservationsDuplicate: 'reservations:duplicate',
    reservationsEdit: 'reservations:edit',
    reservationsPointToPoint: 'reservations:point-to-point',
    reservationsSearchAffiliate: 'reservations:search-affiliate',
    reservationsSearchUser: 'reservations:search-user',
    reservationsView: 'reservations:view',
    rolePermissionsView: 'rolePermissions:view',
    rolesAssign: 'roles:assign',
    rolesCreate: 'roles:create',
    rolesDelete: 'roles:delete',
    rolesEdit: 'roles:edit',
    rolesView: 'roles:view',
    settingsView: 'settings:view',
    staticPageEditorCreate: 'static-page-editor:create',
    staticPageEditorView: 'static-page-editor:view',
    surgesCreate: 'surges:create',
    surgesDelete: 'surges:delete',
    surgesEdit: 'surges:edit',
    surgesView: 'surges:view',
    userRolesView: 'user-roles:view',
    usersAttachments: 'users:attachments',
    usersChangeEmail: 'users:change-email',
    usersChangePassword: 'users:change-password',
    usersEdit: 'users:edit',
    usersJobs: 'users:jobs',
    usersProfileInfo: 'users:profile-info',
};
